import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { getCookie, Spinner, useEffectOnce } from '@chilecompra/react-kit'
import { onGetPublicTokenThunk } from './AuthenticationProvider.actions'
import { Root } from './AuthenticationProvider.styles'

/**
 * The Authentication container.
 */
const AuthenticationContainer = ({ children }) => {
  const dispatch = useDispatch()
  const {
    publicToken: { loading }
  } = useSelector(state => state.authentication)
  const accessToken = getCookie('access_token')

  useEffectOnce(() => {
    dispatch(onGetPublicTokenThunk())
  }, [accessToken])

  if (!accessToken && loading) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return children
}

AuthenticationContainer.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthenticationContainer
